export function getExcerpt(article_top: string, length: number) {
  if (!article_top) {
    return '';
  }

  const strippedArticleTop = article_top.replace(/^\*+|\*+$/gm, '');

  const excerpt =
    strippedArticleTop.length > length
      ? strippedArticleTop.slice(0, length) + '...'
      : strippedArticleTop;

  return excerpt;
}
